import { render, staticRenderFns } from "./specialistTab.vue?vue&type=template&id=a833ee6e&"
import script from "./specialistTab.vue?vue&type=script&lang=js&"
export * from "./specialistTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports